import { render } from "./TextGrid3.vue?vue&type=template&id=2cc5321c&scoped=true"
import script from "./TextGrid3.vue?vue&type=script&lang=js"
export * from "./TextGrid3.vue?vue&type=script&lang=js"

import "./TextGrid3.vue?vue&type=style&index=0&id=2cc5321c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.44_vue@3.5.44_webpack@5.112.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cc5321c"]])

export default __exports__